import { ConfigProvider } from 'antd'
import { useDesign } from 'design/design'
import { observer } from 'mobx-react-lite'
import { ReactNode } from 'react'

const ANTD = 'antd'

const theme = {
  hashed: false,
  cssVar: { key: ANTD },
  token: {
    colorBgBase: 'var(--ui-background-color)',
    colorBgTextHover: 'var(--ui-background-color-hover)',
    colorBorder: 'var(--ui-border-color)',
    colorPrimary: 'var(--ui-primary-color)',
    colorText: 'var(--ui-text-color)',
    fontFamily: 'inherit',
    fontSize: 0,
    lineHeight: 1,
  },
}

type Props = {
  children?: ReactNode
}

export function configureAntd(container: HTMLElement) {
  container.classList.add(ANTD)
}

export const Theme = observer(({ children }: Props) => {
  useDesign()

  return <ConfigProvider theme={theme}>
    {children}
  </ConfigProvider>
})
